export default {
  en: {
    market: 'Market',
    keyword: 'Keyword',
    newMarket: 'New Market',
    name: 'Name',
    description: 'Description',
    totalAgent: 'Total Agent',
    status: 'Status',
    confirmRemoveMarketTitle: 'Confirm',
    confirmRemoveMarketMessage: 'Confirm to delete {marketName} market?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeMarketSuccess: 'Remove market {marketName} success'
  },
  th: {
    market: 'ตลาด',
    keyword: 'คำที่ต้องการค้นหา',
    newMarket: 'สร้างตลาด',
    name: 'ชื่อ',
    description: 'รายละเอียด',
    totalAgent: 'ตัวแทนทั้งหมด',
    status: 'สถานะ',
    confirmRemoveMarketTitle: 'ยืนยัน',
    confirmRemoveMarketMessage: 'ต้องการลบตลาด {marketName}?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeMarketSuccess: 'ลบตลาด {marketName} สำเร็จ'
  }
}
